import {Card} from "antd";
import {useTranslation} from "react-i18next";
import {capitalize} from "lodash";
import BiodiversityNatureTable from "./BiodiversityNatureTable";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";


export default function BiodiversityNatureCard() {

  const {t} = useTranslation()
  const {xs} = useBreakpoint()

  return <Card
    title={capitalize(t('assets.biodiversityNature'))}
    bodyStyle={{
      ...xs && {padding: 0}
    }}
  >
    <BiodiversityNatureTable/>
  </Card>
}